import clsx from 'clsx';
import { useCallback, useMemo } from 'react';

import { Button } from '@vestico/shared';

import { AddToBagVariant } from '../hooks/useAddToBagActions';
import style from './AddToBagVariantOption.module.css';

export interface AddToBagVariantOptionProps {
  variant: AddToBagVariant;
  selected: boolean;
  onSelect: (size: AddToBagVariant) => void;
}

export const AddToBagVariantOption = ({ variant, selected, onSelect }: AddToBagVariantOptionProps) => {
  const { available } = variant;
  const onClick = useCallback(() => onSelect(variant), [onSelect, variant]);
  const backgroundColor = useMemo(() => (selected ? 'rgba(0,0,0,0.1)' : 'rgba(0,0,0,0.04)'), [selected]);
  const borderColor = useMemo(() => (selected ? 'var(--color)' : 'transparent'), [selected]);
  return (
    <Button
      rounded
      size="small"
      cssProperties={{ backgroundColor, borderColor, width: '100%' }}
      onClick={onClick}
      disabled={!available}
      content={<div className={clsx(style.root, { [style.selected]: selected, [style.disabled]: !available })}>{variant.title}</div>}
    />
  );
};
